// 体验版

// 登录页
import CLogin from '@/components/ExpPage/CLogin/CLogin'

// 主页
import CIndex from '@/components/CIndex'

// 用户管理
import ExpCOrganizeManage from '@/components/ExpPage/CUserManege/COrganizeManage/SIndex'  // 组织管理
import ExpCOrganizeAuthAllot from '@/components/ExpPage/CUserManege/COrganizeManage/COrganizeAuthAllot'   //权限分配

// 控制中心
import ExpCSceneList from '@/components/ExpPage/CSceneManage/CSceneList'  // 空间管理
import ExpCDeviceCenter from '@/components/ExpPage/CSceneManage/CDeviceCenter'  // 设备中心
import ExpCAuthorizationCenter from '@/components/ExpPage/CAuthorizationManage/CAuthorizationCenter'  // 授权管理
import ExpCBeAuthorizedUser from '@/components/ExpPage/CAuthorizationManage/CBeAuthorizedUser'  // 授权管理-已授权用户

let router = [
  // 登录页
  {
    path: '/Exp/CLogin',
    name: 'ExpCLogin',
    component: CLogin,
    meta: {
      rv: 0
    }
  },
  // 主页
  {
    path: '/Exp/CIndex',
    name: 'ExpCIndex',
    component: CIndex,
    meta: {
      rv: 2
    }
  },
  // 用户管理
  {
    path: '/Exp/COrganizeManage/',
    name: 'ExpCOrganizeManage',
    component: ExpCOrganizeManage,
    meta: {
      rv: 2
    }
  },
  {
    path: '/Exp/COrganizeAuthAllot/',
    name: 'ExpCOrganizeAuthAllot',
    component: ExpCOrganizeAuthAllot,
    meta: {
      rv: 2
    }
  },
  // 控制中心
  // 空间管理（场景列表）
  {
    path: '/Exp/CSceneList/',
    name: 'ExpCSceneList',
    component: ExpCSceneList,
    meta: {
      rv: 2
    }
  },
  // 授权管理
  {
    path: '/Exp/CAuthorizationCenter/',
    name: 'ExpCAuthorizationCenter',
    component: ExpCAuthorizationCenter,
    meta: {
      rv: 2
    }
  },
  {
    path: '/Exp/CBeAuthorizedUser/',
    name: 'ExpCBeAuthorizedUser',
    component: ExpCBeAuthorizedUser,
    meta: {
      rv: 2
    }
  },
  // 设备中心
  {
    path: '/Exp/CDeviceCenter/',
    name: 'ExpCDeviceCenter',
    component: ExpCDeviceCenter,
    meta: {
      rv: 2
    }
  },

]

export default router


// WEBPACK FOOTER //
// ./src/router/modules/ExpPage.js